import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

const socialBrands = {
  facebook: '#3b5998',
  twitter: '#1da1f2',
  googleplus: '#dd4b39',
  linkedin: '#0077b5',
  reddit: '#ff4500',
  whatsapp: '#128c7e',
}

const PostSocial = styled.div`
  display: flex;
  justify-content: space-around;
  @media (max-width: ${props => props.theme.responsive.small}) {
    display: block;
  }

  > .button {
    -moz-appearance: none;
    -webkit-appearance: none;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: none;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    justify-content: flex-start;
    line-height: 1.5;
    padding: calc(.375em - 1px) calc(.625em - 1px);
    position: relative;
    vertical-align: top;
    
    // transition: all 300ms ease-out;
    background-color: #fff;
    border-color: #dbdbdb;
    border-width: 1px;
    color: #363636;
    cursor: pointer;
    justify-content: center;
    padding: calc(.375em - 1px) .75em;
    text-align: center;
    white-space: nowrap;

    margin: 0.5rem 0.25rem;

    &.is-rounded {
      border-radius: 290486px;
      padding-left: 1em;
      padding-right: 1em;
    }

    &.facebook {
      color: ${socialBrands.facebook};
      border-color: ${socialBrands.facebook};
      &:hover {
        background-color: ${socialBrands.facebook};
        border-color: ${socialBrands.facebook};
        color: #fff;
      }
    }
    &.twitter {
      color: ${socialBrands.twitter};
      border-color: ${socialBrands.twitter};
      &:hover {
        background-color: ${socialBrands.twitter};
        border-color: ${socialBrands.twitter};
        color: #fff;
      }
    }
    &.linkedin {
      color: ${socialBrands.linkedin};
      border-color: ${socialBrands.linkedin};
      &:hover {
        background-color: ${socialBrands.linkedin};
        border-color: ${socialBrands.linkedin};
        color: #fff;
      }
    }

    > .icon {
      align-items: center;
      display: inline-flex;
      justify-content: center;
      height: 1.5rem;
      width: 1.5rem;

    }
  }
`

const ShareIcons = ({ socialConfig, tags }) => (
	<PostSocial>
    <FacebookShareButton 
      quote="Join me in protesting Premier Horgan's new Community Benefits Agreement."
      hashtag="#bcpoli"
      url={socialConfig.config.url} 
      className="button is-outlined is-rounded facebook"
    >
			<span className="icon">
				<FontAwesomeIcon icon={faFacebookF} />
			</span>
			<span className="text">Facebook</span>
		</FacebookShareButton>
    <TwitterShareButton 
      url={socialConfig.config.url} 
      className="button is-outlined is-rounded twitter" 
      title={socialConfig.config.title} 
      via={socialConfig.twitterHandle.split('@').join('')}
      hashtag="#bcpoli"
    >
			<span className="icon">
				<FontAwesomeIcon icon={faTwitter} />
			</span>
			<span className="text">Twitter</span>
		</TwitterShareButton>
    <LinkedinShareButton 
      url={socialConfig.config.url} 
      className="button is-outlined is-rounded linkedin" 
      title={socialConfig.config.title} 
    >
			<span className="icon">
				<FontAwesomeIcon icon={faLinkedinIn} />
			</span>
			<span className="text">LinkedIn</span>
		</LinkedinShareButton>
	</PostSocial>
);

ShareIcons.propTypes = {
	socialConfig: PropTypes.shape({
		twitterHandle: PropTypes.string.isRequired,
		config: PropTypes.shape({
			url: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
		}),
	}).isRequired,
	tags: PropTypes.arrayOf(PropTypes.string),
};
ShareIcons.defaultProps = {
	tags: [],
};

export default ShareIcons;


// WEBPACK FOOTER //
// ./src/components/Share.js